var $3354eb1a04c4e741$exports = {};
$3354eb1a04c4e741$exports = {
    "loading": `Se \xeencarc\u{103}...`,
    "loadingMore": `Se \xeencarc\u{103} mai multe...`
};


export {$3354eb1a04c4e741$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
